export const gitCommit = 'ccb4f801'
